<template>
  <div data-v-a632e678="" data-v-12b14801="" class="container">
    <!-- 页面头部 -->
    <div class="header">
      <h1>APP下载中心</h1>
      <p>体验更好、速度更快、玩转社区</p>
    </div>
    
    <!-- APP下载部分 -->
    <div class="download-section">
      <div class="section-title">
        <i class="fas fa-mobile-alt"></i>
        <span>{{$store.state.appInfo.title}}全新手机APP</span>
      </div>
      
      <div class="app-card">
        <div class="app-icon">
          <img data-v-a632e678="" src="/static/image/01.cf71e918.png" class="img-responsive" alt="APP图标" />
        </div>
        
        <div class="app-info">
          <h3>{{$store.state.appInfo.title}}全新手机APP</h3>
          <p>体验更好、速度更快、玩转社区，随时随地享受优质服务</p>
        </div>
        
        <div class="download-options">
          <!-- 苹果图标 -->
          <span class="platform-icon">
            <i class="fab fa-apple fa-lg"></i>
          </span>
          <!-- 安卓图标 -->
          <span class="platform-icon">
            <i class="fab fa-android fa-lg"></i>
          </span>
          <!-- 点击下载按钮触发弹窗显示 -->
          <button class="download-btn" @click="showDownloadConfirm">立即下载</button>
        </div>
      </div>
    </div>
    
    <!-- 功能特点部分 -->
    <div class="features">
      <div class="feature-card">
        <div class="feature-icon">
          <i class="fas fa-bolt"></i>
        </div>
        <h4>极速体验</h4>
        <p>优化算法，提升加载速度，让您畅享流畅体验</p>
      </div>
      
      <div class="feature-card">
        <div class="feature-icon">
          <i class="fas fa-shield-alt"></i>
        </div>
        <h4>安全可靠</h4>
        <p>多重加密保护，确保您的数据和隐私安全</p>
      </div>
      
      <div class="feature-card">
        <div class="feature-icon">
          <i class="fas fa-sync-alt"></i>
        </div>
        <h4>实时同步</h4>
        <p>多设备数据同步，随时随地继续您的体验</p>
      </div>
    </div>
    
    <!-- 页脚 -->
    <div class="footer">
      <p>© {{ currentYear }} {{ $store.state.appInfo.title }} 版权所有</p>
    </div>
    
    <!-- 下载确认弹窗（默认隐藏） -->
    <div class="download-confirm-modal" v-if="isConfirmModalShow">
      <div class="modal-mask" @click="hideDownloadConfirm"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">下载确认</h3>
          <span class="modal-close" @click="hideDownloadConfirm">&times;</span>
        </div>
        <div class="modal-body">
          <div class="modal-icon">
            <i class="fas fa-external-link-alt"></i>
          </div>
          <p class="modal-tip">即将跳转到浏览器下载</p>
          <p class="modal-app-name">{{$store.state.appInfo.title}} APP</p>
          <p class="modal-note">请在浏览器中完成后续下载与安装操作</p>
        </div>
        <div class="modal-footer">
          <button class="modal-btn cancel-btn" @click="hideDownloadConfirm">取消</button>
          <button class="modal-btn confirm-btn" @click="confirmDownload">确认跳转</button>
        </div>
      </div>
    </div>
    <div data-v-434370a8="" data-v-a632e678="" class="dialog"><!----></div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      isConfirmModalShow: false 
    };
  },
  created() {
    let that = this;
    that.getApp();
    
    // 动态创建link标签引入Font Awesome
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
    document.head.appendChild(link);
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },  
  methods: {
    downloadUrl(url) {
      let that = this;
      this.$parent.showLoading();

      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.style.display = 'none';
      iframe.style.height = 0; 
      document.body.appendChild(iframe); 
      setTimeout(() => {
        that.$parent.hideLoading();
        document.body.removeChild(iframe);
      }, 2000);
    },
    getApp() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          that.$parent.hideLoading();
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    // 显示下载确认弹窗
    showDownloadConfirm() {
      this.isConfirmModalShow = true;
      // 弹窗显示时禁止页面滚动
      document.body.style.overflow = 'hidden';
    },
    // 隐藏下载确认弹窗
    hideDownloadConfirm() {
      this.isConfirmModalShow = false;
      // 弹窗隐藏时恢复页面滚动
      document.body.style.overflow = '';
    },
    // 确认下载（跳转浏览器）
    confirmDownload() {
      const downloadUrl = this.$store.state.appInfo.ios_download_url;
      if (downloadUrl) {
        // 关闭弹窗
        this.hideDownloadConfirm();
        // 新窗口打开下载链接（跳转浏览器）
        window.open(downloadUrl, '_blank');
        console.log('已跳转浏览器下载，URL：', downloadUrl);
      } else {
        // 处理下载地址不存在的异常情况
        this.hideDownloadConfirm();
        alert('当前APP下载地址暂未配置，请稍后重试');
      }
    },
    openNew(){
      console.log(this.$store.state.appInfo.ios_download_url)
      window.open(this.$store.state.appInfo.ios_download_url);
    }
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  // 组件销毁时确保恢复页面滚动
  beforeDestroy() {
    document.body.style.overflow = '';
  }
};
</script>

<style lang="scss" scoped>
// 全局样式重置
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

// 确保body背景为浅色
body {
  background-color: #f8fafc;
  color: #333;
}

.container {
  background-color: #f8fafc;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.header h1 {
  font-size: 32px;
  color: #2d3748;
  margin-bottom: 10px;
  font-weight: 600;
}

.header p {
  font-size: 16px;
  color: #718096;
}

.download-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 25px;
  margin-bottom: 25px;
  transition: all 0.3s ease;
}

.download-section:hover {
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
  transform: translateY(-5px);
}

.section-title {
  font-size: 20px;
  color: #2d3748;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #edf2f7;
  display: flex;
  align-items: center;
  gap: 10px;
}

::v-deep .section-title i {
  color: #4a5568;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

.app-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: #f8fafc;
  border-radius: 12px;
  margin-bottom: 15px;
}

.app-icon {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  overflow: hidden;
  margin-right: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.app-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.app-info {
  flex: 1;
}

.app-info h3 {
  font-size: 18px;
  color: #2d3748;
  margin-bottom: 8px;
  font-weight: 600;
}

.app-info p {
  text-align: center;
  font-size: 14px;
  color: #718096;
  line-height: 1.5;
}

.download-options {
  display: flex;
  align-items: center;
  gap: 15px;
}


::v-deep .platform-icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #4299e1;
  font-size: 22px;
}

::v-deep .platform-icon .fa-apple,
::v-deep .platform-icon .fa-android {
  font-family: "Font Awesome 5 Brands";
  font-weight: 400;
  opacity: 1;
}

.download-btn {
  padding: 10px 20px;
  background: linear-gradient(135deg, #4a90e2, #63b3ed);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(66, 153, 225, 0.2);
}

.download-btn:hover {
  background: linear-gradient(135deg, #3b82f6, #4299e1);
  box-shadow: 0 6px 10px rgba(66, 153, 225, 0.3);
  transform: translateY(-2px);
}

.download-btn:active {
  transform: translateY(0);
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.feature-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.feature-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  background: #ebf4ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4299e1;
  font-size: 24px;
}

// 修复：功能区图标样式
::v-deep .feature-icon i {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

.feature-card h4 {
  font-size: 16px;
  color: #2d3748;
  margin-bottom: 10px;
}

.feature-card p {
  font-size: 14px;
  color: #718096;
}

.footer {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  color: #a0aec0;
  font-size: 14px;
}

.img-responsive[data-v-a632e678] {
  width: 100%;
  max-width: 100%;
}

.download[data-v-a632e678] {
  padding: 20px 0 90px;
  background: transparent;
}

.row .item[data-v-a632e678] {
  padding: 14px 15px;
  background: #f8fafc;
}

.row .item-buttons[data-v-a632e678] {
  background: #f8fafc;
}

.row h3[data-v-a632e678] {
  color: #2d3748;
}

.row .item .info h3[data-v-a632e678] {
  color: #2d3748;
}

.row .item .info p[data-v-a632e678] {
  color: #718096;
}

// 下载确认弹窗样式
.download-confirm-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
}

.modal-content {
  position: relative;
  width: 90%;
  max-width: 420px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  padding: 20px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.modal-title {
  font-size: 18px;
  color: #2d3748;
  font-weight: 600;
}

.modal-close {
  font-size: 22px;
  color: #718096;
  cursor: pointer;
  transition: color 0.2s ease;
}

.modal-close:hover {
  color: #2d3748;
}

.modal-body {
  text-align: center;
  margin-bottom: 22px;
}

.modal-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  background: #ebf4ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4299e1;
  font-size: 24px;
}

// 修复：弹窗内图标样式
::v-deep .modal-icon i {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

.modal-tip {
  font-size: 16px;
  color: #2d3748;
  margin-bottom: 6px;
}

.modal-app-name {
  font-size: 16px;
  color: #4299e1;
  font-weight: 500;
  margin-bottom: 8px;
}

.modal-note {
  font-size: 14px;
  color: #718096;
}

.modal-footer {
  display: flex;
  gap: 12px;
}

.modal-btn {
  flex: 1;
  padding: 10px 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.cancel-btn {
  background: #f8fafc;
  color: #718096;
}

.cancel-btn:hover {
  background: #edf2f7;
  color: #2d3748;
}

.confirm-btn {
  background: linear-gradient(135deg, #4a90e2, #63b3ed);
  color: white;
}

.confirm-btn:hover {
  background: linear-gradient(135deg, #3b82f6, #4299e1);
}

// 响应式设计
@media (max-width: 768px) {
  .app-card {
    flex-direction: column;
    text-align: center;
  }
  
  .app-icon {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .download-options {
    margin-top: 15px;
    justify-content: center;
  }
  
  .features {
    grid-template-columns: 1fr;
  }
  
  .modal-content {
    padding: 16px;
  }
  
  .modal-title {
    font-size: 16px;
  }
  
  .modal-tip, .modal-app-name {
    font-size: 15px;
  }
  
  .modal-note {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/app.vue